import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GoToLoginWithRedirect } from 'src/shared/state/auth.action';
import { AuthState } from '../../shared/state/auth.state';

@Injectable({
	providedIn: 'root',
})
export class AuthorizedGuard {
	private store = inject(Store);

	loggedIn$: Observable<boolean> = this.store.select(AuthState.loggedIn);

	canActivate(
		_next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> {
		this.loggedIn$.subscribe((loggedIn) => {
			if (!loggedIn) {
				this.store.dispatch(new GoToLoginWithRedirect(state.url));
			}
		});
		return this.loggedIn$;
	}
}
